<template>
  <ValidationObserver v-slot="obs" ref="form">
    <form
      :action="action"
      :method="method"
      v-on="$listeners"
      @submit.prevent="submit"
    >
      <slot :obs="obs" />
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

export default {
  components: {
    ValidationObserver,
  },

  props: {
    action: {
      type: String,
      default: '',
    },
    method: {
      type: String,
      default: 'post',
    },
  },

  methods: {
    submit() {
      this.$refs.form.validate().then(passed => {
        if (passed) {
          this.$emit('passed');
        }
      });
    },
  },
};
</script>
